// src/Dashboard/pages/user/PrepaPhysique/components/PrepaPhysiqueHeader.jsx

import React from "react";
import {
  FaDumbbell,
  FaMobileAlt,
  FaRunning,
  FaSyncAlt,
} from "react-icons/fa";

export default function PrepaPhysiqueHeader({ loading, onRefresh }) {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="bg-gradient-to-r from-[#013E8E] via-indigo-600 to-[#4CA82F] px-5 py-6 text-white sm:px-8">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
          <div className="min-w-0">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-xs font-bold uppercase tracking-wide ring-1 ring-white/20">
              <FaDumbbell />
              Préparation physique
            </div>

            <h1 className="mt-4 text-2xl font-bold sm:text-3xl">
              Mes exercices assignés
            </h1>

            <p className="mt-2 max-w-3xl text-sm leading-6 text-white/90">
              Retrouvez les séances données par vos enseignants : force,
              cardio, mobilité, prévention des blessures et exercices de
              renforcement à valider une fois réalisés.
            </p>

            <div className="mt-5 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-2 rounded-2xl bg-white/15 px-3 py-2 text-xs font-bold ring-1 ring-white/20">
                <FaMobileAlt />
                Adapté smartphone
              </span>

              <span className="inline-flex items-center gap-2 rounded-2xl bg-white/15 px-3 py-2 text-xs font-bold ring-1 ring-white/20">
                <FaRunning />
                Suivi personnel
              </span>
            </div>
          </div>

          <button
            type="button"
            onClick={onRefresh}
            disabled={loading}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-white px-4 py-3 text-sm font-bold text-slate-900 shadow-sm transition hover:bg-white/90 disabled:cursor-not-allowed disabled:opacity-70"
          >
            <FaSyncAlt className={loading ? "animate-spin" : ""} />
            Actualiser
          </button>
        </div>
      </div>
    </section>
  );
}